import React from 'react';
import ToastContext from './ToastContext';
import Toast from './Toast';

const useToast = () => {
  const context = React.useContext(ToastContext);

  if (!context) {
    throw Error('The `useToast` hook needs of ToastProvider to get the context');
  }

  return Object.assign({}, context, {
    sizes: Toast.sizes,
    kinds: Toast.kinds
  });
};

export default useToast;